import React, { useContext } from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import { matchPath, useLocation } from 'react-router-dom';
import { Colors } from '../assets/theme/Colors';
import FABContext from '../context/FABContext/FABContext';
import { hasFABAvailableActions } from '../helpers/fab';
import routes from '../routes';

// the mobile home screen is served from a different route depending on the user's role:
// Site Directors / Site Coordinators land on the SC dashboard, rescuers on the mobile dashboard
const fabRoutes = [routes.mobileDashboard, routes.mobileDashboardSchedule, routes.dashboardSC];

const FABButton = () => {
  const fabContext = useContext(FABContext);
  const location = useLocation();
  const isOnFABRoute = !!matchPath(location.pathname, { path: fabRoutes, exact: true });

  const [open, setOpen] = React.useState(false);

  const speedDialSx = {
    position: 'fixed',
    bottom: 'calc(16px + var(--safe-area-inset-bottom, 0px))',
    right: '16px',
    // display only on the mobile home screen and schedule
    display: isOnFABRoute ? 'flex' : 'none',
    ...fabContext.styles.speedDial,
  };
  const fabSx = {
    '& .MuiSpeedDial-fab': {
      backgroundColor: Colors.appBar.main,
      '&:hover': {
        backgroundColor: Colors.appBar.light,
      },
      ...fabContext.styles.fab,
    },
  };
  const staticTooltipLabelSx = {
    color: 'black',
    whiteSpace: 'nowrap',
    ...fabContext.styles.staticTooltipLabelSx,
  };

  const handleClose = action => {
    setOpen(false);

    if (action.onClick) {
      action.onClick();
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <FABContext.Consumer>
      {({ actions, isVisible }) => {
        return (
          <>
            {isVisible && hasFABAvailableActions(actions) && (
              <SpeedDial
                data-testid="fab-button"
                data-introid="fab-button"
                ariaLabel="SpeedDial"
                sx={{...speedDialSx, ...fabSx, }}
                icon={<SpeedDialIcon data-introid="quick-add" id="quick-add" />}
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
              >
                {Object.values(actions)
                  .map(key =>
                    key.map((action, index) => (
                      <SpeedDialAction
                        sx={staticTooltipLabelSx}
                        tooltipOpen
                        key={action.name}
                        data-testid={action.testid || `spedDial-option-${index}`}
                        title={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={() => handleClose(action)}
                      />
                    )),
                  )}
              </SpeedDial>
            )}
          </>
        );
      }}
    </FABContext.Consumer>
  );
};

export default FABButton;
